module.exports = "https://99designs-start-assets.imgix.net/js/b95a2e9a130fdc625ab1777c1291b3d7.png";